import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

const IdleSessionPopup = ({ isOpen, timeLeft, onExtendSession, onLogout }) => {
   
    return (
        
        <Dialog open={isOpen} onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              onLogout(event); // Only close for non-backdrop reasons
            }
          }} aria-labelledby="lock-status-dialog-title" sx={{
            '& .MuiDialog-paper': {
              borderRadius: '8px',
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
              width: '500px',
              height: '250px',
            },
          }}>
        <DialogTitle id="lock-status-dialog-title" sx={{
          fontSize: '16px',
          fontWeight: 'bold',
          color: '#333',
          padding: '16px 24px',
        }}>Session Timeout Warning</DialogTitle>
        <DialogContent sx={{ padding: '0 24px 16px' }}>
          <Typography variant="body1" sx={{
            fontSize: '14px',
            color: '#333',
          }}>This session has been inactive for a while, and it will be logged out in <strong>{timeLeft}</strong> seconds. Are you still working on it ?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onLogout} sx={{
            backgroundColor: '#fff',
            color: '#264e5a',
            borderRadius: '4px',
            padding: '10px 32px',
            fontSize: '14px',
            fontWeight: 'normal',
            textTransform: 'none',
            border: '1px solid #264e5a',
            '&:hover': {
              backgroundColor: '#d4ecef',
            },
          }}>
            No
          </Button>
		  <Button onClick={onExtendSession} sx={{
            backgroundColor: '#264e5a',
            color: 'white',
            borderRadius: '4px',
            padding: '10px 32px',
            fontSize: '14px',
            fontWeight: 'normal',
            textTransform: 'none',
            border: '1px solid #264e5a',
            '&:hover': {
              backgroundColor: '#2c3e50',
            },
          }}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    );
};

export default IdleSessionPopup;